import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import {
    PayrollReportCreationProcessFailure,
    PayrollReportCreationProcessSuccess,
    StartPayrollReportCreationProcess
} from '../actions/payroll-report-creation-process.actions';
import { payrollReportCreationProcessData } from '../reducer/payroll-report-creation-process.reducer';
import { PayrollReportManagementControllerService } from '@iota/inh-core-v1-management-client';
import { LoadAllPayrollReportSummaries } from '../actions/payroll-report-summary.actions';

@Injectable()
export class PayrollReportCreationProcessEffects {
    startPayrollReportCreationProcess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StartPayrollReportCreationProcess),
            withLatestFrom(this.store.select(payrollReportCreationProcessData)),
            mergeMap(([, data]) =>
                this.apiService.generatePayrollReportForCompanies(data?.companyIds, data?.asOfDate).pipe(
                    switchMap((results) => of(PayrollReportCreationProcessSuccess({ results }), LoadAllPayrollReportSummaries())),
                    catchError((error) => of(PayrollReportCreationProcessFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private apiService: PayrollReportManagementControllerService,
        private store: Store
    ) {}
}
